import React from "react";
import styled from "styled-components";
import Img001 from "assets/images/va/topics/0_1_1.png";
import Img112 from "assets/images/va/topics/1_1_2.png";
import Img112Sensia from "assets/images/va/topics/1_1_2-sensia.png";
import Img113 from "assets/images/va/topics/1_1_3.png";
import Roupas from "assets/svg/roupas";
import Sapatos from "assets/svg/sapatos";
import Acompanhante from "assets/svg/acompanhante";
import Documentacao from "assets/svg/documentacao";
import Security from "assets/svg/security";
import Checklist from "assets/svg/checklist";
import Checksuccess from "assets/svg/check-success";
import Paste from "assets/svg/paste";
import Exclamation from "assets/svg/exclamation";

import { getThemePropertyValue } from "utils/pluginHelpers";

export const TYPES = {
  SPOTLIGHT: "SPOTLIGHT",
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  IMAGE_FULL: "IMAGE_FULL",
  LETSGO: "LETSGO",
  LIST: "LIST",
  LIST_DROPDOWN: "LIST_DROPDOWN"
};

const TitleItem = (Icon, text) => {
  return (
    <h3
      style={{
        display: "flex",
        alignItems: "center",
        marginBottom: "10px",
        marginTop: "10px"
      }}
    >
      <Icon
        alt="Roupas"
        style={{ marginRight: "8px" }}
        pathFill={getThemePropertyValue(
          "va.modalNovidades.pathFill.color",
          undefined
        )}
      />{" "}
      {text}
    </h3>
  );
};

const TitleGreen = styled.div`
  color: ${getThemePropertyValue(
    "va.modalNovidades.pathFill.color",
    "#006b3f"
  )};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 175%;
  margin-bottom: 10px;
  margin-top: 10px;
`;

export const texts = [
  {
    moduleId: "1",
    subModuleId: "1",
    content: [
      {
        type: TYPES.SPOTLIGHT,
        text:
          "A vistoria permite que você verifique se o imóvel está em boas condições e de acordo com o que foi definido em contrato."
      },
      ...(getThemePropertyValue(
        "guia.modules.1_1.removeImage001",
        undefined
      ) === true
        ? []
        : [
            {
              type: TYPES.IMAGE_FULL,
              image: Img001
            }
          ]),
      {
        type: TYPES.TEXT,
        text: getThemePropertyValue(
          "guia.modules.1_1.text1",
          <div style={{ marginLeft: "14px" }}>
            <ol>
              <li>
                <b>Finalidade:</b> confirmar se o imóvel está pronto para morar
                e atende ao que foi acordado em contrato.
              </li>
              <li>
                <b>Aspectos avaliados:</b> estrutura (paredes, piso, teto),
                hidráulica (pias, tanques, chuveiros), elétrica (tomadas,
                interruptores), esquadrias (entorno de portas e janelas), além
                de revestimentos e acabamentos (azulejos, pintura, rejuntes).
              </li>
              <li>
                <b>Documentação:</b> o resultado é registrado em um laudo que
                ficará disponível para você após a aprovação da vistoria,
                garantindo transparência sobre o estado do imóvel.
              </li>
              <li>
                <b>Responsabilidade:</b> a MRV é responsável por corrigir
                eventuais pendências identificadas durante a vistoria.
              </li>
            </ol>
          </div>
        )
      }
    ]
  },
  {
    moduleId: "1",
    subModuleId: "2",
    content: [
      {
        type: TYPES.SPOTLIGHT,
        text: getThemePropertyValue(
          "guia.modules.1_2.text0",
          `A vistoria é o momento para confirmar que tudo está como você esperava na entrega das chaves. Ela traz mais segurança e transparência para sua jornada.`
        )
      },
      {
        type: TYPES.TEXT,
        text: getThemePropertyValue(
          "guia.modules.1_2.text1",
          <div style={{ marginLeft: "14px" }}>
            <ol>
              <li>
                <b>Identificação de reparos:</b> a vistoria é essencial para
                detectar a necessidade de correções no seu imóvel.
              </li>
              <li>
                <b>Garantia:</b> os itens do seu imóvel possuem diferentes
                prazos de garantia para reparos. Saber a condição do seu MRV
                antes da entrega, assegura que você possa solicitar ajustes nos
                períodos previstos.
              </li>
              <li>
                <b>Documentação:</b> essa etapa é um registro importante do
                estado do imóvel antes da entrega das chaves.
              </li>
              <li>
                <b>Decoração:</b> se você pretende deixar o seu MRV do jeito que
                sempre sonhou, a vistoria irá te ajudar a planejar melhor onde
                posicionar seus móveis e pensar na decoração da sua conquista.
              </li>
              <li>
                <b>Segurança:</b> além dos aspectos estéticos, a vistoria é
                importante para garantir que o imóvel esteja seguro para você e
                sua família viverem.
              </li>
            </ol>
          </div>
        )
      }
    ],
    next: {
      moduleId: "1",
      subModuleId: "02"
    }
  },
  {
    moduleId: "2",
    subModuleId: "1",
    content: [
      {
        type: TYPES.SPOTLIGHT,
        text:
          "A vistoria é o último passo antes da entrega das chaves. Por isso, é essencial seguir as orientações para realizar essa etapa com máximo conforto e tranquilidade."
      },
      {
        type: TYPES.TEXT,
        text: (
          <>
            {TitleItem(Roupas, "Roupas")}
            <p>
              Prezando a sua segurança, regatas, vestidos e saias não são
              permitidos. Escolha o simples para esse momento, como camisas com
              manga e calças.
            </p>
            {TitleItem(Sapatos, "Sapatos")}
            Sapatos de salto alto ou abertos, como chinelos e sapatilhas, também
            não são permitidos. Opte por tênis ou botinas.
            {TitleItem(Acompanhante, "Acompanhante")}
            Nossa equipe técnica estará no local para conduzir a vistoria com
            você. Nossos colaboradores são capacitados para te guiar por todo o
            processo, apontando os itens para avaliação e tirando todas as suas
            dúvidas. Caso você opte por levar mais um(a) profissional para esse
            momento, será necessário apresentar comprovação de registro no
            Conselho Regional de Engenharia e Agronomia (CREA) e da Resolução nº
            336/89 do Conselho Federal de Engenharia e Agronomia (Confea).
            Todo(a) engenheiro(a) ou técnico(a) de edificações deve ter essas
            certificações. Se o(a) contratado(a) for realizar a vistoria por
            você, ele(a) precisará apresentar a Anotação de Responsabilidade
            Técnica (ART), emitida pelo conselho profissional competente.
            {TitleItem(Documentacao, "Documentação")}
            Leve documento com foto e CPF.
            {TitleItem(Security, "Equipamentos de segurança")}
            Ao chegar na obra, nossa equipe te entregará um capacete. Utilize-o
            como recomendado.
            <TitleGreen>Atenção!</TitleGreen>
            <div>
              Caso não possa comparecer à vistoria e queira enviar um
              representante, você deverá informar os dados dele no momento do
              agendamento da vistoria pela MIA, nossa assistente virtual, no
              WhatsApp (31) 9900-9000.
            </div>
          </>
        )
      }
    ]
  },
  {
    moduleId: "2",
    subModuleId: "2",
    content: [
      {
        type: TYPES.SPOTLIGHT,
        text: getThemePropertyValue(
          "guia.modules.2_2.text0",
          `O checklist da vistoria está nas suas mãos! A lista para aprovar os itens do seu imóvel faz parte do aplicativo Meu MRV.`
        )
      },
      {
        type: TYPES.IMAGE_FULL,
        image: (() => {
          const nameImg = getThemePropertyValue("guia.modules.2_2.img1.name");
          if (nameImg === "sensia") {
            return Img112Sensia;
          }
          return Img112;
        })()
      },
      {
        type: TYPES.TEXT,
        text: getThemePropertyValue(
          "guia.modules.2_2.text1",
          <>
            <div style={{ marginLeft: "14px" }}>
              <ol>
                <li>
                  <b>Baixe o aplicativo:</b> entre na loja de aplicativos
                  (Google Play e App Store) do seu celular e baixe o Meu MRV.
                </li>
                <li>
                  <b>Acesse o aplicativo:</b> preencha CPF e senha para entrar e
                  verifique se o seu perfil está ativo com antecedência.
                </li>
                <li>
                  <b>Carregue o seu celular:</b> o seu dispositivo móvel precisa
                  estar ativo durante toda a vistoria, mantenha-o carregado.
                </li>
              </ol>
            </div>
          </>
        )
      }
    ]
  },
  {
    moduleId: "3",
    subModuleId: "1",
    content: [
      {
        type: TYPES.SPOTLIGHT,
        text: `Realizar a vistoria com atenção, seguindo as nossas dicas, simplifica essa etapa da sua jornada.`
      },
      {
        type: TYPES.IMAGE_FULL,
        image: Img113
      },
      {
        type: TYPES.TEXT,
        text: (
          <>
            {TitleItem(Checklist, "Abra o checklist")}
            {getThemePropertyValue(
              "guia.modules.3_1.part.text1",
              `A lista de verificação dos
            itens a serem vistoriados estará disponível no seu perfil no
            aplicativo Meu MRV.`
            )}
            {TitleItem(Exclamation, "Vistorie os cômodos com atenção")}
            {getThemePropertyValue(
              "guia.modules.3_1.part.text2",
              <>
                Confira cada canto do seu MRV, se atentando a todos os itens
                listados, em principal:
                <div style={{ marginLeft: "14px", marginTop: "10px" }}>
                  <ul>
                    <li>
                      <b style={{ fontWeight: 600 }}>Pisos:</b> verifique o
                      nivelamento e se a cor e o rejunte estão uniformes;
                    </li>
                    <li>
                      <b style={{ fontWeight: 600 }}>Paredes e tetos:</b> veja
                      se eles estão alinhados e se não existem manchas na
                      pintura;
                    </li>
                    <li>
                      <b style={{ fontWeight: 600 }}>Portas:</b> teste a
                      abertura e o fechamento, além do alinhamento e acabamento;
                    </li>
                    <li>
                      <b style={{ fontWeight: 600 }}>Janelas:</b> confira se os
                      parafusos estão bem colocados e se as janelas estão
                      abrindo e fechando corretamente;
                    </li>
                    <li>
                      <b style={{ fontWeight: 600 }}>Instalação elétrica:</b>{" "}
                      nossa equipe é responsável por verificar se todas as
                      tomadas e pontos de iluminação estão funcionando. O
                      alinhamento dos interruptores também deve ser observado;
                    </li>
                    <li>
                      <b style={{ fontWeight: 600 }}>Pontos hidráulicos:</b>{" "}
                      cheque registros, pias e ralos. No banheiro, é preciso
                      testar o caimento da água no piso do box, que deve ser
                      absorvida completamente pelo ralo. Para esse teste, nossa
                      equipe irá disponibilizar um balde para o procedimento.
                    </li>
                  </ul>
                </div>
              </>
            )}
            {TitleItem(Paste, "Cheque cada tópico do checklist")}
            Visite os cômodos e marque os itens que estão de acordo com o
            esperado. É importante reforçar que alguns itens possuem garantia
            apenas até o momento da vistoria, por isso sua atenção nessa etapa é
            fundamental.
            {TitleItem(Checksuccess, "Finalize a vistoria")}
            {getThemePropertyValue(
              "guia.modules.3_1.part.text3",
              `Aprove os itens verificados na vistoria confirmando a conclusão do
            checklist no seu celular. A aprovação da vistoria só deverá
            acontecer se todos os itens do seu MRV estiverem de acordo.`
            )}
          </>
        )
      }
    ],
    next: {
      moduleId: "1",
      subModuleId: "05"
    }
  }
];

export const modules = [
  {
    moduleId: "1",
    moduleName: "Etapa 1",
    moduleDescription: "Explicação da vistoria",
    subModules: [
      {
        id: "1",
        text: "Conceitos de uma vistoria"
      },
      {
        id: "2",
        text: "Importância da vistoria"
      }
    ]
  },
  {
    moduleId: "2",
    moduleName: "Etapa 2",
    moduleDescription: "Dicas para se preparar",
    subModules: [
      {
        id: "1",
        text: "Antes da vistoria"
      },
      {
        id: "2",
        text: getThemePropertyValue(
          "guia.modules.2_2.submodule.name",
          "Aplicativo Meu MRV"
        )
      }
    ]
  },
  {
    moduleId: "3",
    moduleName: "Etapa 3",
    moduleDescription: "Instruções de como vistoriar",
    subModules: [
      {
        id: "1",
        text: "Recomendações gerais"
      }
    ]
  }
];

export default { modules, texts };
